'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _i18n = require('../i18n/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param errorMessage Hláška která bude nasazena na dané indexy
 * @param names pole jmen
 */
var requireFields = function requireFields(names) {
    var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return function (data) {
        var msg = errorMessage || (0, _i18n2.default)('global.form.title.error.required');
        return names.reduce(function (errors, name) {
            if (!data[name]) {
                errors[name] = msg;
            }
            return errors;
        }, {});
    };
};

exports.default = requireFields;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdXRpbHMvcmVxdWlyZUZpZWxkcy5qc3giXSwibmFtZXMiOlsicmVxdWlyZUZpZWxkcyIsIm5hbWVzIiwiZXJyb3JNZXNzYWdlIiwibXNnIiwicmVkdWNlIiwiZXJyb3JzIiwibmFtZSIsImRhdGEiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOzs7Ozs7QUFDQTs7OztBQUlBLElBQU1BLGdCQUFnQixTQUFoQkEsYUFBZ0IsQ0FBQ0MsS0FBRDtBQUFBLFFBQVFDLFlBQVIsdUVBQXVCLElBQXZCO0FBQUEsV0FBZ0MsZ0JBQVE7QUFDMUQsWUFBTUMsTUFBTUQsZ0JBQWdCLG9CQUFLLGtDQUFMLENBQTVCO0FBQ0EsZUFBT0QsTUFBTUcsTUFBTixDQUFhLFVBQUNDLE1BQUQsRUFBU0MsSUFBVCxFQUFrQjtBQUNsQyxnQkFBSSxDQUFDQyxLQUFLRCxJQUFMLENBQUwsRUFBaUI7QUFDYkQsdUJBQU9DLElBQVAsSUFBZUgsR0FBZjtBQUNIO0FBQ0QsbUJBQU9FLE1BQVA7QUFDSCxTQUxNLEVBS0osRUFMSSxDQUFQO0FBTUgsS0FScUI7QUFBQSxDQUF0Qjs7a0JBVWVMLGEiLCJmaWxlIjoicmVxdWlyZUZpZWxkcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBpMThuIGZyb20gJy4uL2kxOG4vaTE4bidcbi8qKlxuICogQHBhcmFtIGVycm9yTWVzc2FnZSBIbMOhxaFrYSBrdGVyw6EgYnVkZSBuYXNhemVuYSBuYSBkYW7DqSBpbmRleHlcbiAqIEBwYXJhbSBuYW1lcyBwb2xlIGptZW5cbiAqL1xuY29uc3QgcmVxdWlyZUZpZWxkcyA9IChuYW1lcywgZXJyb3JNZXNzYWdlID0gbnVsbCkgPT4gZGF0YSA9PiB7XG4gICAgY29uc3QgbXNnID0gZXJyb3JNZXNzYWdlIHx8IGkxOG4oJ2dsb2JhbC5mb3JtLnRpdGxlLmVycm9yLnJlcXVpcmVkJyk7XG4gICAgcmV0dXJuIG5hbWVzLnJlZHVjZSgoZXJyb3JzLCBuYW1lKSA9PiB7XG4gICAgICAgIGlmICghZGF0YVtuYW1lXSkge1xuICAgICAgICAgICAgZXJyb3JzW25hbWVdID0gbXNnXG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIGVycm9yc1xuICAgIH0sIHt9KTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IHJlcXVpcmVGaWVsZHM7XG4iXX0=